import axios from "axios";

export const sendEmail = async (props) => {
    const url = process.env.REACT_APP_BASE_URL + "/api/email/send";

    const {fromLabel, toemail, subject, message, replyto="", tocc="", tobcc=""} = props;

    const values = {
        "fromLabel": fromLabel || "CIBNOR",
        "toemail": toemail,
        "subject": subject,
        "message": message,
        "replyto": replyto,
        "tocc": tocc,
        "tobcc": tobcc,
    };

    var result = [];

    await axios.post(url, values)
    .then( response => {
        const data = response.data;
        result = { ...data };
        if (data.exito === 1) {
            console.log("mensaje enviado...");
        }
    })
    return result;
};
